import React, { useState } from "react";
import PropTypes from "prop-types";

const formInitialState = {
  id: 1,
  companyCode: 1,
  organizationIdNo: null,
  authorisedPersonName: "winapp",
  employerName: "RAJENDRAN SIVA VADIVEL",
  employerEmail: "rajshiva@live.com.sg",
  employerTelephone: "",
  basisYear: 2026,
  icfinNo: "S1234567D",
  idType: "NRIC",
  employeeCode: 1,
  uniqueID: "NFPL001",
  employeeName: "RAJENDRAN SIVA VADIVEL",
  employeeAddressType: "Local Address",
  employeeAddress: "rajshiva@live.com.sg",
  employeePostalCode: "650291",
  employeeNationality: "Indian",
  employeeGender: "Male",
  employeeDesignation: "GENERAL MANAGER",
  employeeCountry: "Singapore",
  employeeDateOfBirth: "1979-02-15T00:00:00",
  dateOfCessation: null,
  dateOfCommencement: "2023-12-01T00:00:00",
  bankSalaryCreditedTo: "DBS",
  totalGrossSalary: 5000.0,
  totalBonus: 0.0,
  dateOfBonusPaid: null,
  directorsFees: 0.0,
  directorsFeesApproveDate: null,
  allowances: 0.0,
  grossCommission: 0.0,
  gratuityNoticePayExgratiaPayment: 0.0,
  compensationLorLossOfOffice: 0.0,
  otherCPFBenefits: 0.0,
  fundName: "9.00",
  overseasPensionContribution: 0.0,
  excessCPFEmployer: 0.0,
  esopGainS10b: 0.0,
  esopGainS10g: 0.0,
  bikValue: 0.0,
  totalAllowance: 0.0,
  remissionType: null,
  remissionAmount: 0.0,
  taxBorneByEmployer: "0.00",
  taxBorneIncome: 0.0,
  fixedTaxByEmployee: "0.00",
  section45Flag: null,
  totalCPFAmount: 985.0,
  totalDonationsAmount: 0.0,
  totalContributions: 0.0,
  totalInsurance: 0.0,
  isActive: true,
  createUser: "winapp",
  createDate: "2026-02-10T18:20:00",
  modifyUser: null,
  modifyDate: null,
  generatedBy: "winapp",
  generatedDate: "2026-02-10T18:20:00",
  approvedBy: null,
  approvedDate: null,
  submissionDate: null,
  submissionStatus: false,
  approvedStatus: false,
};

const LabelValue = ({ label, value }) => {
  return (
    <div className="">
      <div className="ir8a-label">{label}</div>
      <div className="ir8a-value">{value || ""}</div>
    </div>
  );
};

const EmployeeIR8AForm = () => {
  const isEditable = true;
  const [formData, setFormData] = useState({
    employerUEN: "",
    employeeTaxRef: "",
    fullName: "",
    dob: "",
    sex: "",
    nationality: "",
    address: "",
    designation: "",
    bankName: "",
    commencementDate: "",
    cessationDate: "",

    // Income
    grossSalary: 0,
    bonus: 0,
    directorsFee: 0,
    allowances: 0,
    grossCommission: 0,
    lumpSumPayment: 0,
    pensionBenefits: 0,
    employerPensionContribution: 0,
    excessCpf: 0,
    esopS10b: 0,
    esopS10g: 0,
    benefitsInKind: 0,

    // Tax
    taxBorneByEmployer: "No",
    partialTaxAmount: 0,
    fixedTaxAmount: 0,

    // Deductions
    cpfEmployee: 0,
    donations: 0,
    mosqueFund: 0,
    lifeInsurance: 0,

    // Declaration
    employerName: "",
    authorisedPerson: "",
    designationDeclaration: "",
    declarationDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("IR8A Payload:", formData);
    // TODO: API integration
  };

  const totalOthers =
    Number(formData.allowances) +
    Number(formData.grossCommission) +
    Number(formData.lumpSumPayment) +
    Number(formData.pensionBenefits) +
    Number(formData.employerPensionContribution) +
    Number(formData.excessCpf) +
    Number(formData.esopS10b) +
    Number(formData.benefitsInKind);

  return (
    <div className="card border-0">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title">IR8A Form</h4>
      </div>
      <div className="card-body">
        <section className="mb-4 ">
          <div className="form-row row">
            <h4 className="header-title">
              Return of Employee’s Remuneration for the year ended{" "}
              {formInitialState?.basisYear}
            </h4>
            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-6 iras-box">
                <LabelValue
                  label="Employer’s Tax Ref. No. / UEN"
                  value={formInitialState?.organizationIdNo}
                />
              </div>
              <div className="col-md-6 iras-box">
                <LabelValue
                  label="Employee’s Tax Ref. No. : *NRIC / FIN"
                  value={formInitialState?.icfinNo}
                />
              </div>
            </div>

            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-6 iras-box">
                <LabelValue
                  label="Full Name of Employee as per NRIC / FIN "
                  value={formData?.employeeName}
                />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue
                  label="Date of Birth "
                  value={formData?.employeeDateOfBirth}
                />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue label="Sex " value={formData?.employeeGender} />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue
                  label="Nationality "
                  value={formData?.nationality}
                />
              </div>
            </div>
            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-6 iras-box">
                <LabelValue
                  label="Residential Address"
                  value={formData?.employeeAddress}
                />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue label="Designation" value={formData?.designation} />
              </div>
              <div className="col-md-4 iras-box">
                <LabelValue
                  label="Bank to which salary is credited "
                  value={formData?.bankName}
                />
              </div>
            </div>
            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-6 iras-box">
                <LabelValue
                  label="If employment commenced and/or ceased during the year, state:"
                  value=""
                />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue
                  label="Date of Commencement"
                  value={formInitialState?.dateOfCommencement}
                />
              </div>
              <div className="col-md-4 iras-box">
                <LabelValue
                  label="Date of Cessation"
                  value={formInitialState?.dateOfCessation}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="mb-4 ">
          <div className="form-row row">
            <h4 className="header-title">Income</h4>
            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-11">
                <LabelValue
                  label="Gross Salary, Fees, Leave Pay, Wages and Overtime Pay:"
                  value=""
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>

              <div className="col-md-11">
                <LabelValue
                  label="Bonus "
                  value="(non-contractual bonus paid in 2025 and / or contractual bonus)"
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>

              <div className="col-md-11">
                <LabelValue
                  label="Director’s fees  "
                  value="(approved at the company’s AGM/EGM on )"
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>

              <div className="col-md-11">
                <LabelValue
                  label="Director’s fees  "
                  value="(approved at the company’s AGM/EGM on )"
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="mb-4 ">
          <div className="form-row row">
            <h4 className="header-title">Deductions</h4>
            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-11">
                <LabelValue
                  label="EMPLOYEE’S COMPULSORY contribution to * CPF / Designated Pension or Provident Fund (less amount refunded/to be refunded) Name of Fund :
(Please apply the appropriate CPF rates published by CPF Board on its website ‘www.cpf.gov.sg’. Do not include excess/voluntary contributions to CPF,
voluntary contributions to Medisave Account, voluntary contributions to Retirement Sum Topping-up Scheme, SRS contributions and contributions to
Overseas Pension or Provident Fund in this item) "
                  value=""
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>

              <div className="col-md-11">
                <LabelValue
                  label="Donations deducted from salaries for:
*Yayasan Mendaki Fund/Community Chest of Singapore/SINDA/CDAC/ECF/Other tax exempt donations  "
                  value=""
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>

              <div className="col-md-11">
                <LabelValue
                  label="Contributions deducted from salaries for Mosque Building Fund"
                  value=""
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>

              <div className="col-md-11">
                <LabelValue
                  label="Life Insurance premiums deducted from salaries"
                  value=""
                />
              </div>
              <div className="col-md-1">
                {isEditable ? (
                  <input className="form-control" name="" value="0.00" />
                ) : (
                  <LabelValue label="" value="" />
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="mb-4 ">
          <div className="form-row row">
            <h4 className="header-title">DECLARATION</h4>
            <div className="row iras-row d-flex justify-content-between">
              <div className="col-md-12">
                <LabelValue label="Name of Employer" value="Rajasekar" />
              </div>
              <div className="col-md-12">
                <LabelValue
                  label="Address of Employer"
                  value="123 Main Street, Singapore"
                />
              </div>
              <div className="col-md-3 iras-box">
                <LabelValue
                  label="Name of authorised person making the declaration"
                  value=""
                />
              </div>
              <div className="col-md-3 iras-box">
                <LabelValue label="Designation" value="" />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue label="Tel. No." value="" />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue label="Signature" value="" />
              </div>
              <div className="col-md-2 iras-box">
                <LabelValue label="Date" value="" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default EmployeeIR8AForm;

LabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};
